import axios from "axios";

export function createPricingRules(newRules, options = {}) {
  return axios.post("/api/pricing/rules/global", { rules: newRules, ...options });
}

export function updatePricingRules(updatedRules) {
  return axios.put("/api/pricing/rules", updatedRules);
}

export async function getPricingRules(
  params = {
    pageLimit: 25,
    pageNumber: 1,
    pageType: "GLOBAL",
    priority: "GLOBAL",
  }
) {
  try {
    const { data } = await axios.get("/api/pricing/rules", { params });
    return data;
  } catch (error) {
    console.log("Error getting pricing rules");
  }
}

export const getCostAdditionsPaginated = (params) => {
  const { terminalIds, networkIds, productIds, name, pageLimit, pageNumber } = params;
  return getPricingRules({
    pageLimit: pageLimit ?? 25,
    pageNumber: pageNumber ?? 1,
    pageType: "COST_ADDITIONS_ALL",
    terminalIds,
    networkIds,
    productIds,
    name,
  });
};

export async function getGlobalRules() {
  const rulesRes = await axios.get("/api/pricing/rules/global");
  return rulesRes.data;
}

export function updateGlobalPricingRules(updatedRules, options = {}) {
  return axios.put("/api/pricing/rules/global", { rules: updatedRules, ...options });
}

/**
 * @param {Object} options
 * @param {string} options.buyerId
 * @param {string} options.terminalId
 * @param {string} options.productId
 * @param {string} options.networkId
 * @param {string} options.measurement
 * @param {string} options.bioBlend
 */
export async function costAdditionRulesForOffer(options) {
  try {
    const { buyerId, terminalId, productId, networkId, offerExclusions, omittedOfferExclusions, bioBlend } = options;
    const { data } = await axios.get("/api/pricing/rules/cost-additions", { 
      params: {
        buyerIds: buyerId ? [buyerId] : undefined,
        terminalIds: terminalId ? [terminalId] : undefined,
        productIds: productId ? [productId] : undefined,
        networkIds: networkId ? [networkId] : undefined,
        offerExclusions,
        omittedOfferExclusions,
        bioBlend,
      }
    });
    return data;
  } catch(ex) {
    console.log("error getting cost addition pricing rules");
  }
}
